<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [title]="title"  [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<div class="column">
    <h2>Pazienti globali - Utenti che non hanno effettuato l'accesso per patologia</h2>
    <div style="display: inline-block" style="padding-left: 2vw; padding-top: 1vw">
      <div class = "chart-container">
        <canvas id = "myChartNeverLoggedPathology"></canvas>
      </div>
    </div>
  </div> <!--
  <div class="column">
    <ng-container *ngIf="isTableAvailable">
      <div class="mat-elevation-z8">
        <div id="myModal" class="modal">
          //Modal content
          <div class="modal-content" style="background-color: #FFFFFF">
            <div class ="modal-header" style="background-color: #008d8d">
              <span class="close" style="padding: 10px;" (click)="hideTable()">&times;</span>
              <h4 class="modal-title" style = "color: white; font-weight: bold; padding-left: 50px"> Pazienti che non hanno mai effettuato l'accesso per PATOLOGIA</h4>
            </div>
            <div class="modal-body">
              <table mat-table [dataSource]="dataSourceNeverLoggedPatientsPathology" class="mat-elevation-z8">
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef> <mat-checkbox (change)= "selectAllInactive($event)"> Seleziona tutti  </mat-checkbox> </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox *ngIf="selectedInactive; else elseBlock" [(ngModel)]="element.checked" (change)="changeInactiveItem($event, element)"> </mat-checkbox>
                    <ng-template #elseBlock> <mat-checkbox (change)="selectInactiveItems($event, element)"></mat-checkbox> </ng-template> </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef> Nome </th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>
                <ng-container matColumnDef="surname">
                  <th mat-header-cell *matHeaderCellDef> Cognome </th>
                  <td mat-cell *matCellDef="let element"> {{element.surname}} </td>
                </ng-container>
                <ng-container matColumnDef="pathology">
                  <th mat-header-cell *matHeaderCellDef> Patologia </th>
                  <td mat-cell *matCellDef="let element"> {{element.pathology}} </td>
                </ng-container>
                <ng-container matColumnDef="sollecita">
                  <td mat-footer-cell *matFooterCellDef>
                    <button mat-button mat-raised-button color="primary" style="position: center" (click)="sendMail()"> Sollecita </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="paginator">
                  <td mat-footer-cell *matFooterCellDef colspan="4">
                    <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                                   [length]="totalSizeInactive"
                                   [pageSize]="5"
                                   (page)="handlePageInactive($event)">showFirstLastButtons></mat-paginator>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="headElementsInactive"></tr>
                <tr mat-row *matRowDef="let row; columns: headElementsInactive;"></tr>
                <tr mat-footer-row *matFooterRowDef="['sollecita', 'paginator']"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
-->